import './App.scss';
import Home from './pages/Home';
import { Routes, Route } from 'react-router-dom';
import About from './pages/About';
import Services from './pages/Services';
import GalleryPage from './pages/GalleryPage';
import KnowYourDrPage from './pages/KnowYourDrPage.';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/gallery/clinic" element={<GalleryPage />} />
      <Route path="/gallery/our-work" element={<GalleryPage />} />
      <Route path="/knowyourdoctor" element={<KnowYourDrPage />} />
    </Routes>
  );
}

export default App;
